import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import React, { useEffect, useState } from 'react';
import { Card, Image, Nav, ProgressBar } from 'react-bootstrap';
import { NavLink, useParams } from 'react-router-dom';
import user1 from 'assets/img/we-raise-images/DonarImage.png';
import logo from 'assets/img/illustrations/weraise.png';

const donorNavLinks = [
  { id: 1, title: 'Profile', link: 'profile' },
  { id: 2, title: 'Giving', link: 'giving' },
  { id: 3, title: 'Sponsorships', link: 'sponsorships' },
  { id: 4, title: 'Communications', link: 'communications' },
  { id: 5, title: 'Relation Management', link: 'relation_management' },
  { id: 6, title: 'Gift Aid', link: 'gift_aid' },
  { id: 7, title: 'Feedback', link: 'feedback' },
  { id: 8, title: 'Add Donation', link: '/add-new-donation' }
];

const DonorNav = () => {
  let { id } = useParams();

  const [stickyStatus, setStickyStatus] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY < 10) {
        setStickyStatus(false);
      } else {
        setStickyStatus(true);
      }
    });
  }, [window.scrollY]);

  return (
    <div
      className="font-sans-serif sticky-top"
      style={{ top: stickyStatus ? '5rem' : '0' }}
    >
      <Card className="mb-3">
        <Card.Body>
          <Flex justifyContent="between" alignItems="center" className={'mb-3'}>
            <h6 className="mb-0">Donor Account</h6>
            <SoftBadge pill bg="primary" className="align-self-center fs--2">
              <FontAwesomeIcon icon="user" className="me-1" /> Individual
            </SoftBadge>
          </Flex>
          <div className="text-center">
            <Avatar
              src={user1}
              rounded="circle"
              size="4xl"
              className="border border-5 border-white rounded-circle shadow-sm mb-2"
            />

            <p className="mb-1 fs--1 text-primary fw-medium">Mr.Ahmed Amin</p>
            <p className="mb-0 fs--2 text-700 font-base">ID AC {id}</p>
          </div>
          <hr className="text-200" />
          <Flex justifyContent={'between'} alignItems="center">
            <p className="mb-0 fs--2 fw-medium me-5">
              Score: <span className="text-success fw-semi-bold">{817}</span>
            </p>
            <div className="flex-1">
              <ProgressBar
                variant="success"
                now={80}
                style={{ height: '5px' }}
              />
            </div>
          </Flex>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body>
          <div className="mb-4">
            <Image src={logo} height="24px" width="24px" />
            <span className="ms-2 fs--1 fw-medium text-900">
              Donor Management
            </span>
          </div>
          <Nav variant="pills" className="flex-column">
            {donorNavLinks.map(navItem => (
              <Nav.Item key={navItem.id}>
                <Nav.Link
                  className="fs--1 fw-medium donar-profile-nav"
                  as={NavLink}
                  to={navItem.link}
                >
                  {navItem.title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Card.Body>
      </Card>
    </div>
  );
};

export default DonorNav;
